import { render, staticRenderFns } from "./medicineManagement.vue?vue&type=template&id=b1b1c4a2"
import script from "./medicineManagement.vue?vue&type=script&lang=js"
export * from "./medicineManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports